import Phaser from 'phaser';
import { installCrispText } from './utils/TextQuality';
import { GAME_HEIGHT, GAME_WIDTH } from './data/gameConstants';
import { AudioSystem } from './systems/AudioSystem';
import { ResponsiveSystem } from './systems/ResponsiveSystem';
import { FullscreenSystem } from './systems/FullscreenSystem';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MainMenuScene } from './scenes/MainMenuScene';
import { NameInputScene } from './scenes/NameInputScene';
import { Zone1SkyMessageScene } from './scenes/Zone1SkyMessageScene';
import { Zone2ForestSurvivalScene } from './scenes/Zone2ForestSurvivalScene';
import { Zone3BubunganHouseScene } from './scenes/Zone3BubunganHouseScene';
import { Zone4SafeRouteScene } from './scenes/Zone4SafeRouteScene';
import { Zone5RescueScene } from './scenes/Zone5RescueScene';
import { EndingScene } from './scenes/EndingScene';
import { AssetPreviewScene } from './scenes/AssetPreviewScene';

installCrispText();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#4a7c59',
  expandParent: true,
  render: {
    antialias: true,
    antialiasGL: true,
    powerPreference: 'high-performance',
    roundPixels: false,
    pixelArt: false,
  },
  scale: {
    mode: Phaser.Scale.ENVELOP,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    fullscreenTarget: 'game-container',
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    PreloadScene,
    MainMenuScene,
    NameInputScene,
    Zone1SkyMessageScene,
    Zone2ForestSurvivalScene,
    Zone3BubunganHouseScene,
    Zone4SafeRouteScene,
    Zone5RescueScene,
    EndingScene,
    AssetPreviewScene,
  ],
};

const game = new Phaser.Game(config);
AudioSystem.bindGame(game);
ResponsiveSystem.applyToGame(game);
FullscreenSystem.mountToggleButton();
FullscreenSystem.ensureToggleVisible();
ResponsiveSystem.syncFullscreenTogglePosition(game);

if (import.meta.env.DEV) {
  (globalThis as typeof globalThis & { __SEISM_GAME__?: Phaser.Game }).__SEISM_GAME__ = game;
}

